<template>
    <div>
        <el-row :gutter="10">
            <el-col :span="12" :offset="6">
                <el-card class="box-card">
                    <ImportTransactions />
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import ImportTransactions from '@/components/ImportTransactions';

export default {
    name: 'import_transactions_view',
    components: {
        ImportTransactions
    }
}
</script>